
import {  createSlice } from '@reduxjs/toolkit';


export interface adrListProps {
  tag: any;
  entityref: string; 
  title: string;
  path: string;
  content: string;
  loading:boolean;
  error: string | null;

  list:Omit<adrListProps[],'loading|error'>
}

const initialState: adrListProps = {
  loading: false,
  error: null,
  entityref: '',
  title: '',
  path: '',
  content: '',
  list: [],
  tag: ''
};


const adrSlice = createSlice({
  name: 'adrList',
  initialState,
  reducers: {
    setAdrList:(state,action)=>{
      state.list=action.payload
    }
  },
 
});


export const { setAdrList } = adrSlice.actions; 
export default adrSlice.reducer;
